<script setup lang="ts">

const isProduction = process.env.NODE_ENV === 'production'
const config = useRuntimeConfig()
const siteUrl = config.public.hostname

useSeoMeta({
	ogSiteName: 'Smoxy',
	ogImage: `${siteUrl}/android-chrome-512x512.png`,
	ogImageAlt: 'Smoxy logo',
	ogImageWidth: 512,
	ogImageHeight: 512,
	twitterSite: '@SmoxyApp',
	twitterCard: 'summary',
	twitterImage: `${siteUrl}/android-chrome-512x512.png`,
})

useHead({
	script: [{
		key: 'smoxy-organization-schema',
		type: 'application/ld+json',
		innerHTML: JSON.stringify({
			'@context': 'https://schema.org',
			'@graph': [
				{
					'@type': 'Organization',
					'@id': `${siteUrl}/#organization`,
					name: 'Smoxy',
					url: siteUrl,
					logo: {
						'@type': 'ImageObject',
						url: `${siteUrl}/android-chrome-512x512.png`,
						width: 512,
						height: 512,
					},
					sameAs: [
						'https://www.instagram.com/smoxy.app',
						'https://twitter.com/SmoxyApp',
					],
				},
				{
					'@type': 'WebSite',
					'@id': `${siteUrl}/#website`,
					url: siteUrl,
					name: 'Smoxy',
					publisher: { '@id': `${siteUrl}/#organization` },
				},
			],
		}).replace(/</g, '\\u003c'),
	}],
})

</script>

<template>
	<NuxtLayout>
		<div class="light">
			<NuxtPage />
			<Cookie v-if="isProduction"  />
			<Toaster />
		</div>
	</NuxtLayout>
</template>
